import { Layout } from 'antd';
import { Content, Header } from 'antd/es/layout/layout';
import React from 'react';
import { skladMenuItems } from './skladMenuItems';
import logo from './../assets/gabaritlogo.png';
import { NavLink, Route, Routes } from 'react-router-dom';
import LeftToolbar from './Comps/LeftToolbar';
import Coming from '../Pages/InCome/Coming';
import CominHistory from '../Pages/InCome/CominHistory';
import Zaxira from '../Pages/Zaxira/Zaxira';
import Expenses from '../Pages/Expenses/Expenses';

function SkladLayout() {
    return (
        <Layout style={{ minHeight: '100vh', background: 'var(--bg-main)' }}>
            <Header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 100,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    background: 'var(--bg-header)',
                    borderBottom: '1px solid var(--border)',
                    boxShadow: 'var(--shadow-xs)',
                    padding: '0 24px',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <img 
                        src={logo} 
                        alt="Logo" 
                        style={{ height: '32px', width: 'auto' }}
                    />
                    <h1 style={{
                        margin: 0,
                        fontSize: '18px',
                        fontWeight: 700,
                        background: 'var(--gradient)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                    }}>
                        G.A.M
                    </h1>
                </div>
                
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    {skladMenuItems.map(item => (
                        <NavLink 
                            key={item.key} 
                            to={item.link} 
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                backgroundColor: 'var(--primary)',
                                padding: '8px 16px',
                                borderRadius: 'var(--radius-md)',
                                color: 'var(--text-inverse)',
                                fontWeight: 500,
                                transition: 'all var(--transition-base)',
                            }}
                        >
                            {item.icon} {item.label}
                        </NavLink>
                    ))}
                </div>
                
                <LeftToolbar />
            </Header>
            
            <Content style={{ padding: '24px' }}>
                <div
                    style={{
                        background: 'var(--bg-card)',
                        borderRadius: 'var(--radius-lg)',
                        boxShadow: 'var(--shadow-sm)',
                        border: '1px solid var(--border)',
                        height: 'calc(100vh - 64px - 48px)',
                        overflow: 'auto',
                    }}
                >
                    <Routes>
                        <Route path="/" element={<Coming />} />
                        <Route path="/history" element={<CominHistory />} />
                        <Route path="/zaxira" element={<Zaxira />} />
                        <Route path="/expenses" element={<Expenses />} />
                    </Routes>
                </div>
            </Content>
        </Layout>
    );
}

export default SkladLayout;